import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';

import Box from '@mui/material/Box';

import { graphql } from '@e-socna/data-layer';

import { Breadcrumbs } from '../../components/Breadcrumbs';
import { Loading } from '../../components/Loading';
import { LimitedFeature } from '../../components/LimitedFeature';
import { PATH_LOCALITY_INFOS } from '../../app/constants/paths.constant';
import { useGraphQLQuery } from '../../hooks/useGraphQLQuery.hook';
import { Page } from '../../contexts/NavigationContext/enums/page.enum';
import { useNavigationContext } from '../../contexts/NavigationContext/hooks/useNavigationContext.hook';
import { environment } from '../../environment';
import { buildDocumentTitle } from '../../utils/document-title.util';
import { PageTitle } from '../../components/PageTitle';

import { List } from './List';

export const LocalityInfosPage_AllLocalityInfos_QueryDocument = graphql(`
  query LocalityInfosPage_AllLocalityInfos_Query {
    findAllLocalityInfos {
      ...LocalityInfosPage_List_LocalityInfo_Fragment
    }
  }
`);

export const LocalityInfosPage = () => {
  const { setPage } = useNavigationContext();

  useEffect(() => {
    setPage(Page.LocalityInfos);
  }, [setPage]);

  const { data, isSuccess } = useGraphQLQuery(
    LocalityInfosPage_AllLocalityInfos_QueryDocument,
    undefined,
    {
      gcTime: environment.referenceQueryGcTime,
      staleTime: environment.referenceQueryStaleTime,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
    },
  );

  const localityInfos = data?.findAllLocalityInfos;

  return (
    <>
      {!isSuccess && <Loading />}
      <Helmet>
        <title>{buildDocumentTitle('Infos Communes')}</title>
      </Helmet>
      <Breadcrumbs
        paths={[
          {
            to: PATH_LOCALITY_INFOS,
            label: 'infos communes',
            key: 'localityInfos',
          },
        ]}
      />
      <PageTitle title="Infos Communes" />
      <LimitedFeature />
      <Box sx={{ flexGrow: 1, width: '100%', overflow: 'auto' }}>
        <List isSuccess={isSuccess} localityInfos={localityInfos} />
      </Box>
    </>
  );
};
